import axios from "axios";
import Vue from "vue";
import Qs from 'qs'
import store from '@/store/index.js';
let loading;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头
/**
 * 配置钛媒体接口全局配置
 * @type {AxiosInstance}
 */
let tmtApi = axios.create({
  baseURL: process.env.TMT_API_ROOT,//配置接口地址
  timeout: 5000, //响应时间
  headers: {
    'app-version': '1.0.0',
    'app-key': '2019050603',
    'app-secret': 'HbzP4jbaKBd0T4KJuAYP',
    'device': 'expert_pc',
    "user-unique-key": '',
    "access-token": ''
  }   //配置请求头
});
// 钛媒体添加请求拦截器
tmtApi.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  let data = store.state.state;
  config.headers['access-token'] = data.access_token || '';//钛媒体配置请求头
  config.headers['user-unique-key'] = data.user_unique_key || '';//钛媒体配置请求头
  config.data =  Qs.stringify(config.data);
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(Qs.parse(error.response));
});
// 钛媒体添加响应拦截器
tmtApi.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(Qs.parse(error.response));
});
Vue.prototype.$tmtApi = tmtApi;//挂载原型中

/**
 * 钛刻接口请求
 * @type {AxiosInstance}
 */
let tkApi = axios.create({
  baseURL: process.env.TK_API_ROOT,//配置接口地址
  timeout: 5000, //响应时间
  headers: {
    "app-key": "2019050603",
    "client": "pc",
    "app-version": '1.0.0',
    'app-secret': 'HbzP4jbaKBd0T4KJuAYP',
    "user-unique-key": '',
    "access-token": ''
  }   //配置请求头
});
// 钛刻添加请求拦截器
tkApi.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  let data = store.state.state;
  config.headers['access-token'] = data.access_token || '';//钛媒体配置请求头
  config.headers['user-unique-key'] = data.user_unique_key || '';//钛媒体配置请求头
  config.data =  Qs.stringify(config.data);
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(Qs.parse(error.response));
});
// 钛刻添加响应拦截器
tkApi.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(Qs.parse(error.response));
});
Vue.prototype.$tkApi = tkApi;//挂载原型中



// WEBPACK FOOTER //
// ./src/common/js/request.js